



















































import {
  defineComponent,
  ref,
  useRouter,
  useContext,
  onMounted
} from '@nuxtjs/composition-api';
import { useUser } from '@wemade-vsf/customer';
import { SfHeading, SfButton, SfIcon } from '@storefront-ui/vue';

export default defineComponent({
  name: 'AccountComponent',
  components: {
    SfHeading,
    SfButton,
    SfIcon,
    LoginForm: () => import(/* webpackPrefetch: true */ 'components/checkout/Account/LoginForm.vue'),
    RegistrationForm: () => import(/* webpackPrefetch: true */ 'components/checkout/Account/RegistrationForm.vue')
  },
  setup() {
    const { app, localeRoute } = useContext();
    const router = useRouter();
    const { isAuthenticated, user, logout: userLogout, load } = useUser();


    const showLoginForm = ref(false);
    const showRegistrationForm = ref(false);

    const toggleLoginForm = () => {
      showLoginForm.value = !showLoginForm.value;
      showRegistrationForm.value = false;
    };

    const showRegistrationFormHandler = () => {
      showRegistrationForm.value = true;
      showLoginForm.value = false;
    };

    const showLoginFormHandler = () => {
      showLoginForm.value = true;
      showRegistrationForm.value = false;
    };



    

    const logout = async () => {
      try {
        await userLogout({});
        await load();
        document.cookie = 'vsf-customer=; Max-Age=0; path=/;';
        document.cookie = 'customer-token=; Max-Age=0; path=/;';
        const currentPath = router.currentRoute.fullPath || '';
        if (currentPath.includes('checkout') || currentPath.includes('svea')) {
          window.location.href = app.localeRoute({ name: 'home' }).fullPath; 
        }
      } catch (error) {}
    };
    onMounted(() => {
      load();
    });

    return {
      showLoginForm,
      showRegistrationForm,
      toggleLoginForm,
      showRegistrationFormHandler,
      showLoginFormHandler,
      isAuthenticated,
      user,
      logout
    };
  }
});
